import { render, staticRenderFns } from "./EditContactDetails.vue?vue&type=template&id=776ac6aa&"
import script from "./EditContactDetails.vue?vue&type=script&lang=js&"
export * from "./EditContactDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports